import {ExceptionsClient} from "../client/ExceptionsClient";
import {
    getDateDistance,
    getRelativeTime,
    splitScannableIdsIntoBatches,
    subtractDaysFromCurrentDate
} from "../../util/CommonUtils";
import {fetchExceptionShipments} from "./ExceptionShipmentsAPI";
import {getRegion} from "../../util/CommonUtils";
import {
    SCRUB_EXCEPTION_CATEGORIES,
    SCRUB_EXCEPTION_START_RANGE_DAYS,
    SCRUB_EXCEPTION_END_RANGE_DAYS,
    SCRUB_EXCEPTION_START_RANGE_DAYS_IN,
    SCRUB_EXCEPTION_END_RANGE_DAYS_IN,
    SCRUB_EXCEPTION_CATEGORIES_ON_ROAD,
    SCRUB_EXCEPTION_END_RANGE_DAYS_LOST,
    SCRUB_EXCEPTION_START_RANGE_DAYS_LOST,
    METADATA_TICKET_ID,
    METADATA_TERMINAL_SCAN,
    IS_ENABLED_INTERNAL_ESTIMATED_ARRIVAL_DATE_SCRUB_RULE_FOR_LOST,
    GET_SCRUB_SHIPMENTS_DETAILS_IN_BATCHES_DATA,
    GET_SCRUB_SHIPMENTS_DETAILS_CHUNK_SIZE_DEFAULT_VALUE
} from "../constants/ScrubConstants";
import {REGION} from "../constants/CommonConstants";


export function fetchScrubShipmentsList({targetUseCase}, {missingViewNewStrategyEnabled}, dispatcher) {
    switch (targetUseCase) {
        case 'MISSING':
            missingViewNewStrategyEnabled ? getMissingPackagesWithMNRAndNonMNR(dispatcher) : getMissingPackages(dispatcher);
            break;
        default:
            getScrubShipmentsForLost(dispatcher)
    }
}

function getScrubShipmentsForLost(dispatcher) {
    Promise.all([ExceptionsClient.getScrubStats({
        "targetUseCase": "LOST"
    }), fetchExceptionShipments({
        "categories":SCRUB_EXCEPTION_CATEGORIES_ON_ROAD,
        "startDate": Math.floor(subtractDaysFromCurrentDate(SCRUB_EXCEPTION_START_RANGE_DAYS_LOST).getTime()/1000),
        "endDate": Math.floor(subtractDaysFromCurrentDate(SCRUB_EXCEPTION_END_RANGE_DAYS_LOST).getTime()/1000),
        "shipmentDetailsRequired": false,
        "targetStatus": "OPEN",
        "returnPaginationIndex": true,
        "targetUseCase" : "LOST"
    }), ExceptionsClient.getFeatureStatus({
        featureName: IS_ENABLED_INTERNAL_ESTIMATED_ARRIVAL_DATE_SCRUB_RULE_FOR_LOST
    })]).then(([lostResult,onRoadResult,isEnabledInternalEstimatedArrivalDateScrubRuleForLost]) => {
        if (lostResult.valid) {
            let lostShipments = lostResult.data.scrubShipments
            //for each shipment which has SCRUB_EXCEPTION_CATEGORIES_ON_ROAD it is eligible for LOST from start to end date
            if (!isEnabledInternalEstimatedArrivalDateScrubRuleForLost.data.status) {
                for (var shipment in onRoadResult.data) {
                    lostShipments.push(onRoadResult.data[shipment].scannableId);
                }
            }
            getScrubShipmentsDetails({
                scrubShipments: lostShipments
            }).then(({valid, data}) => {
                if (valid) {
                    let shipmentList = prepareShipmentList(data.shipmentDetails, {});
                    dispatcher({
                        type: "SET_DATA",
                        data: shipmentList
                    });
                }
            });
        }
    });
}

async function getScrubShipmentsDetails(params) {
    const isGetScrubShipmentsDetailsInBatchesData = await ExceptionsClient.getFeatureStatus({
        featureName: GET_SCRUB_SHIPMENTS_DETAILS_IN_BATCHES_DATA
    })

    if (isGetScrubShipmentsDetailsInBatchesData.valid && isGetScrubShipmentsDetailsInBatchesData.data.status) {
        var aggregatedShipmentDetails= [];
        var getScrubShipmentsDetailsChunkSize = GET_SCRUB_SHIPMENTS_DETAILS_CHUNK_SIZE_DEFAULT_VALUE;
        if (isGetScrubShipmentsDetailsInBatchesData.data.featureMetaData &&
            isGetScrubShipmentsDetailsInBatchesData.data.featureMetaData.GET_SCRUB_SHIPMENTS_DETAILS_CHUNK_SIZE) {
            getScrubShipmentsDetailsChunkSize =
                isGetScrubShipmentsDetailsInBatchesData.data.featureMetaData.GET_SCRUB_SHIPMENTS_DETAILS_CHUNK_SIZE;
        }
        const scannableIdsBatches = splitScannableIdsIntoBatches(params.scrubShipments, getScrubShipmentsDetailsChunkSize);
        for (const scannableIdsBatch of scannableIdsBatches) {
            params.scrubShipments = scannableIdsBatch;
            const shipmentDetails = await ExceptionsClient.getScrubShipmentsForCategory(params);
            if (!shipmentDetails.valid) {
                console.log("Batch request failed for get scrub shipments details with scannableIds", scannableIdsBatch);
                return {valid: false, data: {shipmentDetails: []}};
            }
            aggregatedShipmentDetails = aggregatedShipmentDetails.concat(shipmentDetails.data.shipmentDetails);
        }
        console.log("Aggregated scrub shipments details response:", aggregatedShipmentDetails);
        return {valid: true, data: {shipmentDetails: aggregatedShipmentDetails}};
    } else {
        return await ExceptionsClient.getScrubShipmentsForCategory(params);
    }
}

function getMissingPackagesWithMNRAndNonMNR(dispatcher) {
    const startDaysForExceptionShipments = REGION.IN === getRegion() ? SCRUB_EXCEPTION_START_RANGE_DAYS_IN : SCRUB_EXCEPTION_START_RANGE_DAYS;
    const endDaysForExceptionShipment = REGION.IN === getRegion() ? SCRUB_EXCEPTION_END_RANGE_DAYS_IN  : SCRUB_EXCEPTION_END_RANGE_DAYS;
    Promise.all([ExceptionsClient.getScrubStats({
        "targetUseCase": "MISSING",
        "metaData": {
            "includeMNR": "false"
        }
    }), ExceptionsClient.getScrubStats({
        "targetUseCase": "MISSING",
        "metaData": {
            "includeMNR": "true"
        }
    }), fetchExceptionShipments({
        "categories": SCRUB_EXCEPTION_CATEGORIES,
        "startDate": Math.floor(subtractDaysFromCurrentDate(startDaysForExceptionShipments).getTime()/1000),
        "endDate": Math.floor(subtractDaysFromCurrentDate(endDaysForExceptionShipment).getTime()/1000),
        "shipmentDetailsRequired": false,
        "targetStatus": "OPEN",
        "returnPaginationIndex": true,
        "targetUseCase" : "MISSING"
    })]).then(([missingResultWithNonMNR, missingResultWithMNR, exceptionShipmentsResult]) => {
        if (missingResultWithNonMNR.valid && missingResultWithMNR.valid && exceptionShipmentsResult.valid) {
            // Retrieve all non MNR shipments
            var nonMNRShipments = missingResultWithNonMNR.data.scrubShipments;
            let scannableIdWithScrubExceptionCategories = {};
            // Add all shipments for which scrub exception was opened to non MNR
            for (var exceptionShipment in exceptionShipmentsResult.data) {
                let scannableId = exceptionShipmentsResult.data[exceptionShipment].scannableId
                nonMNRShipments.push(scannableId);
                if(exceptionShipmentsResult.data[exceptionShipment].category) {
                    scannableIdWithScrubExceptionCategories[scannableId] = exceptionShipmentsResult.data[exceptionShipment].category
                }
            }
            // Since missingResultWithMNR output contains both mnr and non MNR shipments, we need to select only
            // those shipments as MNR which are not present in nonMNRShipments
            var mnrShipments = missingResultWithMNR.data.scrubShipments.filter(shipment => !nonMNRShipments.includes(shipment));
            var scannables = nonMNRShipments.concat(mnrShipments);
            ExceptionsClient.getScrubShipmentsForCategory({
                scrubShipments: scannables,
                targetUseCase: "MISSING"
            }).then(({valid, data}) => {
                if (valid) {
                    let shipmentList = prepareShipmentListWithMNRAndNonMNR(data.shipmentDetails, mnrShipments, scannableIdWithScrubExceptionCategories);
                    dispatcher({
                        type: "SET_DATA",
                        data: shipmentList
                    });
                }
            });
        }
    });
}

function getMissingPackages(dispatcher) {
    const startDaysForExceptionShipments = REGION.IN === getRegion() ? SCRUB_EXCEPTION_START_RANGE_DAYS_IN : SCRUB_EXCEPTION_START_RANGE_DAYS;
    const endDaysForExceptionShipment = REGION.IN === getRegion() ? SCRUB_EXCEPTION_END_RANGE_DAYS_IN : SCRUB_EXCEPTION_END_RANGE_DAYS;
    Promise.all([ExceptionsClient.getScrubStats({
        "targetUseCase": "MISSING",
        "metaData": {
            "includeMNR": "true"
        }
    }), fetchExceptionShipments({
        "categories": SCRUB_EXCEPTION_CATEGORIES,
        "startDate": Math.floor(subtractDaysFromCurrentDate(startDaysForExceptionShipments).getTime()/1000),
        "endDate": Math.floor(subtractDaysFromCurrentDate(endDaysForExceptionShipment).getTime()/1000),
        "shipmentDetailsRequired": false,
        "targetStatus": "OPEN",
        "returnPaginationIndex": true,
        "targetUseCase" : "MISSING"
    })]).then(([missingResult, exceptionShipmentsResult]) => {
        if (missingResult.valid && exceptionShipmentsResult.valid) {
            var scannables = missingResult.data.scrubShipments;
            let scannableIdWithScrubExceptionCategories = {};
            for (var shipment in exceptionShipmentsResult.data) {
                let scannableId = exceptionShipmentsResult.data[shipment].scannableId
                scannables.push(scannableId);
                if(exceptionShipmentsResult.data[shipment].category) {
                    scannableIdWithScrubExceptionCategories[scannableId] = exceptionShipmentsResult.data[shipment].category
                }
            }
            ExceptionsClient.getScrubShipmentsForCategory({
                scrubShipments: scannables,
                targetUseCase: "MISSING"
            }).then(({valid, data}) => {
                if (valid) {
                    let shipmentList = prepareShipmentList(data.shipmentDetails, scannableIdWithScrubExceptionCategories);
                    dispatcher({
                        type: "SET_DATA",
                        data: shipmentList
                    });
                }
            });
        }
    });
}

const prepareShipmentList = (shipments, shipmentsWithcategory) => {
    return shipments.map(({
                              scannableId,
                              currentShipmentStatus,
                              currentShipmentReason,
                              updateStatusDate,
                              operationPerson,
                              stationCode,
                              sortZone,
                              routeCode,
                              inductedCycle,
                              totalHits,
                              metaData,
                              shipType
                          }) => ({
        TRACKING_NUMBER: scannableId || "",
        STATUS: currentShipmentStatus || "",
        REASON: currentShipmentReason || "",
        LAST_UPDATED: getRelativeTime(updateStatusDate),
        LAST_PROCESSED_BY: operationPerson || "",
        STATION: stationCode || "",
        SORT_ZONE: sortZone || "",
        ROUTE: routeCode || "",
        INDUCTED_CYCLE: inductedCycle || "",
        TOTAL_HITS: totalHits || 0,
        CATEGORY : shipmentsWithcategory[scannableId] || "",
        DATE_DISTANCE: getDateDistance(updateStatusDate),
        IS_TERMINAL_SCAN: metaData && metaData.hasOwnProperty(METADATA_TICKET_ID),
        TERMINAL_SCAN_TT: metaData && metaData.hasOwnProperty(METADATA_TICKET_ID) ? metaData.TICKET_ID : null,
        TERMINAL_SCAN_STATE: metaData && metaData.hasOwnProperty(METADATA_TERMINAL_SCAN) ? metaData.TERMINAL_SCAN : null,
        SHIPMENT_TYPE: shipType
    }));
};

const prepareShipmentListWithMNRAndNonMNR = (shipments, mnrShipments, shipmentsWithcategory) => {
    return shipments.map(({
                              scannableId,
                              currentShipmentStatus,
                              currentShipmentReason,
                              updateStatusDate,
                              operationPerson,
                              stationCode,
                              sortZone,
                              routeCode,
                              inductedCycle,
                              totalHits,
                              metaData,
                              shipType
                          }) => ({
        TRACKING_NUMBER: scannableId || "",
        STATUS: currentShipmentStatus || "",
        REASON: currentShipmentReason || "",
        LAST_UPDATED: getRelativeTime(updateStatusDate),
        LAST_PROCESSED_BY: operationPerson || "",
        STATION: stationCode || "",
        SORT_ZONE: sortZone || "",
        ROUTE: routeCode || "",
        INDUCTED_CYCLE: inductedCycle || "",
        TOTAL_HITS: totalHits || 0,
        IS_MNR : mnrShipments.includes(scannableId),
        CATEGORY: shipmentsWithcategory[scannableId] || "",
        DATE_DISTANCE: getDateDistance(updateStatusDate),
        IS_TERMINAL_SCAN: metaData && metaData.hasOwnProperty(METADATA_TICKET_ID),
        TERMINAL_SCAN_TT: metaData && metaData.hasOwnProperty(METADATA_TICKET_ID) ? metaData.TICKET_ID : null,
        TERMINAL_SCAN_STATE: metaData && metaData.hasOwnProperty(METADATA_TERMINAL_SCAN) ? metaData.TERMINAL_SCAN : null,
        SHIPMENT_TYPE: shipType
    }));
};



// WEBPACK FOOTER //
// ./src/commons/api/ScrubListAPI.js